import * as S from './Layout.styled';

export default S.Layout;
